module.exports = __webpack_public_path__ + "img/20190906154919135.574f6856.jpg";